import { render } from "./Playlists.vue?vue&type=template&id=1c6bff9f&lang=html"
import script from "./Playlists.vue?vue&type=script&lang=js"
export * from "./Playlists.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__